module.exports = __webpack_public_path__ + "img/app_store.ad0e2b6c.png";